(function () {
	'use strict';
	/*
	 * 	usage
	 * 	minDate:maxDate in jQuery datepicker format
	 *	0d:30d - shows from today to next 30 days
	 *	-1y:1y - shows from last year to next year
	 */
	//TODO: Add year range to display all the possible years
	angular.module('qbePortal').directive('qbDateRange', [function () {
		return {
			restrict: 'A',
			getDateUnit: function (u) {
				if (u === 'm') {
					return 'months';
				}
				else {
					return u;
				}
			},
			parseDate: function (dateString) {
				if (dateString !== '') {
					var unitSplit = dateString.match(/[a-zA-Z]+|[\-0-9]+/g);
					if (unitSplit.length === 2) {
						var dateUnit = this.getDateUnit(unitSplit[1]);
						dateString = moment().startOf('day').add(parseInt(unitSplit[0]), dateUnit);
					}
				}
				return dateString;
			},
			link: function (scope, element, attrs, ctrl) {
				var dateRange = attrs.qbDateRange.split(':');

				//set start date and end date
				var startDate = (!!dateRange[0]) ? dateRange[0] : '';
				var endDate = (!!dateRange[1]) ? dateRange[1] : '';
				startDate = this.parseDate(startDate);
				endDate = this.parseDate(endDate);

				element.text('Enter a date between ' + startDate.format('DD/MM/YYYY') + ' and ' + endDate.format('DD/MM/YYYY'));
			}
		}
	}]);
})();
